import DarkModeTwoToneIcon from '@mui/icons-material/DarkModeTwoTone'
import LightModeTwoToneIcon from '@mui/icons-material/LightModeTwoTone'
import {Box, IconButton, Tooltip} from '@mui/material'
import type {FC, ReactElement} from 'react'
import {useCallback, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import type {RootState} from '@containers/App/store'
import {setPreferredTheme} from '@redux/slices/user'
import {useCustomTranslation} from '@shared/hooks/useCustomTranslation'

type Props = {
  preferredTheme?: string
}

const ToggleTheme: FC<Props> = ({preferredTheme}): ReactElement => {
  const dispatch = useDispatch()
  const switchToDark = useCallback(() => dispatch(setPreferredTheme('dark')), [dispatch])

  const switchToLight = useCallback(() => dispatch(setPreferredTheme('light')), [dispatch])

  const theme = useSelector((state: RootState) => state.user.preferredTheme)

  useEffect(() => {
    if (preferredTheme) {
      dispatch(setPreferredTheme(preferredTheme))
    }
  }, [preferredTheme, dispatch])

  const [t] = useCustomTranslation('common')

  return (
    <Box
      id="mbai-appbar-theme-toggle"
      data-testid="mbai-main-toggle-theme-component"
      sx={{
        display: 'flex',
        alignSelf: 'center',
        ml: 1,
      }}
      className="selectorTheme"
    >
      {theme === 'light' ? (
        <Tooltip title={t('appbar.switch_to_dark')} arrow>
          <IconButton onClick={() => switchToDark()}>
            <DarkModeTwoToneIcon
              id="appbar-theme-icon"
              data-value="light"
              sx={{
                color: 'grey.700',
                cursor: 'pointer',
              }}
            />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title={t('appbar.switch_to_light')} arrow>
          <IconButton onClick={() => switchToLight()}>
            <LightModeTwoToneIcon
              id="appbar-theme-icon"
              data-value="dark"
              sx={{cursor: 'pointer'}}
            />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  )
}

export default ToggleTheme
